import { useTranslation } from "react-i18next";

import { getFontWeightLabelKey } from "../utils/fontFaces";

import type { FontFaceGroup } from "../utils/fontFaces";

type FontFaceGroupDescriptor = Pick<FontFaceGroup, "weight" | "style">;

function useFontFaceGroupLabel(): (group: FontFaceGroupDescriptor) => string {
  const { t } = useTranslation("editor-appearance");

  return (group) => {
    const weightLabelKey = getFontWeightLabelKey(group.weight);

    return [
      weightLabelKey ? t(weightLabelKey) : null,
      group.weight,
      group.style === "italic" ? t("fontStyleItalic") : null,
    ]
      .filter((part) => part !== null)
      .join(" ");
  };
}

export default useFontFaceGroupLabel;
